export const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  subtitleRow: {
    borderBottom: "1px solid #f5f5f5",
    padding: "12px 16px",
  },
  subtitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#7d8690",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 16px",
  },

  // empty state
  emptyBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    backgroundColor: "#f8fafc",
    border: "1px dashed #f3f4f6",
    borderRadius: "16px",
    padding: "49px 1px",
  },
  emptyIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: "0px 1px 1.5px rgba(0,0,0,0.1), 0px 1px 1px rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyTextWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  emptyTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "22.5px",
    color: "#121212",
  },
  emptyDesc: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#6a7282",
    width: "384px",
    maxWidth: "100%",
  },

  // add button
  addButton: (disabled: boolean) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    height: "50px",
    border: "1px dashed #e5e7eb",
    borderRadius: "13px",
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? "none" : "auto",
  }),
  addButtonText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#2a85ff",
  },

  // list item
  listItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    border: "1px solid #e4e7e9",
    borderRadius: "12px",
    padding: "12px",
  },
  providerIconBox: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    overflow: "hidden",
    flexShrink: 0,
  },
  providerIconImg: (scale: number) => ({
    width: "40px",
    height: "40px",
    objectFit: "cover" as const,
    transform: `scale(${scale})`,
    display: "block",
  }),
  itemNameCol: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: "1 1 0",
    minWidth: 0,
  },
  itemNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  itemName: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#2a2d31",
    whiteSpace: "nowrap",
  },
  verifiedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    height: "22px",
    padding: "2px 8px 2px 6px",
    borderRadius: "24px",
    backgroundColor: "rgba(117,185,118,0.2)",
    flexShrink: 0,
  },
  verifiedText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "10px",
    lineHeight: "16px",
    color: "#008001",
  },
  itemAddress: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#7d8690",
    wordBreak: "break-all",
  },
  deleteBtn: {
    display: "flex",
    alignItems: "center",
    padding: "6px",
    borderRadius: "4px",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": { backgroundColor: "#f5f5f5" },
  },

  // form — provider select
  providerSection: {
    borderBottom: "1px solid #f5f5f5",
    padding: "12px 16px",
  },
  formLabel: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    color: "#2a2d31",
  },
  providerCards: {
    display: "flex",
    gap: "16px",
    marginTop: "10px",
  },
  providerCard: (selected: boolean) => ({
    flex: "1 1 0",
    minWidth: 0,
    height: "100px",
    borderRadius: "14px",
    border: selected ? "2px solid #2a85ff" : "2px solid #f3f4f6",
    backgroundColor: selected ? "#f0f6ff" : "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "18px",
    cursor: "pointer",
  }),
  providerCardName: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#121212",
    textAlign: "center",
  },

  // form — address + notice + buttons
  formSection: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "12px 16px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  input: {
    height: "50px",
    border: "1px solid #e4e7e9",
    borderRadius: "28px",
    padding: "0 16px",
    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "22px",
      color: "#383c40",
      padding: 0,
      "&::placeholder": { color: "#c6cace", opacity: 1 },
    },
  },
  notice: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: "#eff6ff",
    border: "1px solid #bedbff",
    borderRadius: "10px",
    padding: "12px",
  },
  noticeHeadRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
  },
  noticeTitle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "18px",
    color: "rgba(20,71,230,0.8)",
  },
  noticeDesc: {
    paddingLeft: "24px",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: "rgba(20,71,230,0.8)",
  },
  noticeStrong: {
    fontWeight: 500,
  },
  noticeList: {
    margin: 0,
    paddingLeft: "40px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  noticeListItem: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: "rgba(20,71,230,0.8)",
  },
  buttonsRow: {
    display: "flex",
    gap: "12px",
    borderTop: "1px solid #f5f5f5",
    paddingTop: "12px",
  },
  cancelBtn: {
    flex: "1 1 0",
    minWidth: 0,
    height: "50px",
    borderRadius: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#484848",
    textTransform: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": { backgroundColor: "transparent", boxShadow: "none" },
  },
  approveBtn: (active: boolean) => ({
    width: "352px",
    height: "50px",
    borderRadius: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#fff",
    textTransform: "none",
    boxShadow: "none",
    backgroundColor: active ? "#2a85ff" : "#8bc5f4",
    "&:hover": { backgroundColor: active ? "#2a85ff" : "#8bc5f4", boxShadow: "none" },
    "&.Mui-disabled": { backgroundColor: "#8bc5f4", color: "#fff", opacity: 1 },
  }),
};
